import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  applySlip,
  CalAm,
  CalAmBulk,
  getInitFormData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SN_SAL_ISU_REG_004_POP_001 from "@menu/SAL/SN_SAL_ISU_REG_004/SN_SAL_ISU_REG_004_POP_001";
import SnButton from "@shared/components/SnButton";
import { dateToString } from "@shared/utils/DateUtils";
import { showResizablePopupModal } from "@widgets/CommonModal";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";

interface Props {
  Menuprops: menuInfo;
}

// 출하반품정리의뢰등록
const SN_SAL_ISU_REG_004 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    sheet1: [],
  });

  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedDtDocu, setSelectedDtDocu] = useState<string>("");

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      const param = {
        id: "sn_sal_isu_reg_004_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
      });
    } catch (error: any) {}
  };

  const onInsert = async () => {
    try {
      gridRefs.current["grid1"].current?.addRow({});
    } catch (error: any) {}
  };

  const onBeforeAddRow1 = (): any => {
    try {
      const salIsuReqHChanges = gridRefs.current["grid1"].current.getChange();
      if (salIsuReqHChanges.length > 0) {
        showDialog("alter", "수정중인 건이 있습니다.");
        return false;
      }

      const today = dateToString(new Date());
      return {
        cd_firm: userInfo?.cd_firm,
        cd_biz: userInfo?.cd_biz,
        cd_cust: userInfo?.cd_cust,
        nm_cust_sort: userInfo?.nm_cust_sort,
        cd_gp: userInfo?.cd_gp,
        cd_dept: userInfo?.cd_dept,
        cd_emp: userInfo?.cd_emp,
        nm_emp: userInfo?.nm_emp,
        dt_req: today,
        st_req: "F",
        fg_trns: "1",
        yn_autoprocess: "N",
        no_hst: "0",
        cd_cust_dlv: "",
        no_req: "",
        cd_exch: "000",
        rt_exch: 1,
        fg_money: "1",
        fg_io: "3",
        cd_io: "250",
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        qt_dummy01: 0,
        qt_dummy02: 0,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow = () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      return gridRefs.current["grid2"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRow2 = () => {
    try {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const today = dateToString(new Date());
      return {
        cd_firm: userInfo?.cd_firm,
        cd_biz: userInfo?.cd_biz,
        cd_dept: userInfo?.cd_dept,
        cd_emp: userInfo?.cd_emp,
        dt_dlv: today,
        no_line: maxNoLine + 1,
        dt_io: today,
        no_req: focusedNodeH.data?.no_req,
        st_req: focusedNodeH.data?.st_req,
        cd_so: focusedNodeH.data?.cd_so,
        fg_trns: focusedNodeH.data?.fg_trns,
        fg_vat: focusedNodeH.data?.fg_vat,
        qt: 0,
        qt_isu: 0,
        qt_inv: 0,
        qt_ep: 0,
        qt_cls: 0,
        qt_mgmt: 0,
        um: 0,
        am: 0,
        am_k: 0,
        qt_dummy01: 0,
        qt_dummy02: 0,
        qt_dummy03: 0,
        um_k_pack: 0,
        um_supply_pack: 0,
        qt_isu_pack: 0,
        qt_cls_pack: 0,
        qt_dir: 0,
        rt_fat: 0,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }

    await onSave();
  };

  const onDeleteRow = async () => {
    const rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();
    if (rowCount === 0) return;

    gridRefs.current["grid2"].current?.deleteSelectedRows();
    setFooterDataToRow();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) return false;

      const isuReqHChanges = gridRefs.current["grid1"].current.getChange();
      const isuReqLChanges = gridRefs.current["grid2"].current.getChange();
      const headerInserts = isuReqHChanges.insert ?? [];
      const lineInserts = isuReqLChanges.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }

      if (
        isuReqHChanges.modifiedRowcount === 0 &&
        isuReqLChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      if (headerInserts.length !== 0) {
        const focusedRowNodeH =
          gridRefs.current["grid1"].current.focusedRowNode();
        const noSlip = await applySlip({
          cd_column: "no_req",
          cd_module: Menuprops.cd_module,
          no_line: 2,
          cd_prefix: "SIQ",
          dt: focusedRowNodeH.data.dt_req,
          girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
          inserts: [isuReqHChanges, isuReqLChanges],
          cd_menu: Menuprops.cd_menu,
        });
      }

      const saveData = {
        isureqh: isuReqHChanges,
        isureql: isuReqLChanges,
      };
      const ok = await fnSave("SN_SAL_ISU_REG_004_SAVE_01", saveData);
      if (!ok) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
        return false;
      }

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      return false;
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnApply") {
      const salIsuReqHChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (salIsuReqHChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
        cd_cust: selectedFormData.cd_cust,
        dt_from: selectedFormData.dt_from,
        dt_to: selectedFormData.dt_to,
        fg_trns: selectedFormData.fg_trns,
      };

      const component = (
        <SN_SAL_ISU_REG_004_POP_001 selectedData={selectedData} />
      );
      const result = await showResizablePopupModal({
        title: "반품적용",
        children: component,
        validation: true,
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      const lineResult: any[] = result[1];

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedRowNodeH && headerResult[0]) {
        focusedRowNodeH.setDataValue("cd_biz", headerResult[0].cd_biz);
        focusedRowNodeH.setDataValue("cd_biz_isu", headerResult[0].cd_biz);
        focusedRowNodeH.setDataValue("cd_cust", headerResult[0].cd_cust);
        focusedRowNodeH.setDataValue("nm_cust", headerResult[0].nm_cust);
        focusedRowNodeH.setDataValue(
          "nm_cust_sort",
          headerResult[0].nm_cust_sort
        );
        focusedRowNodeH.setDataValue(
          "cd_cust_dlv",
          headerResult[0].cd_cust_dlv
        );
        focusedRowNodeH.setDataValue("fg_trns", headerResult[0].fg_trns);
        focusedRowNodeH.setDataValue("fg_money", headerResult[0].fg_money);
        focusedRowNodeH.setDataValue("cd_exch", headerResult[0].cd_exch);
      }
      lineResult.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow();
          if (addedNode) {
            addedNode.setDataValue("fg_vat", result.fg_vat, "noEvent");
            addedNode.setDataValue("rt_exch", result.rt_exch);
            addedNode.setDataValue("no_so", result.no_order);
            addedNode.setDataValue("no_line_so", result.no_line_order);
            addedNode.setDataValue("no_isu_src", result.no_io);
            addedNode.setDataValue("no_line_isu_src", result.no_line);
            addedNode.setDataValue("cd_item", result.cd_item);
            addedNode.setDataValue("nm_item", result.nm_item);
            addedNode.setDataValue("dc_item_spec", result.dc_item_spec);
            addedNode.setDataValue("dc_item_unit", result.dc_item_unit);
            addedNode.setDataValue("qt", result.qt_app, "noEvent");
            addedNode.setDataValue("um", result.um, "noEvent");
            addedNode.setDataValue("um_k", result.um_k);
            addedNode.setDataValue("am", result.am);
            addedNode.setDataValue("am_k", result.am_k);
            addedNode.setDataValue("am_vat", result.am_vat);
            addedNode.setDataValue("am_supply", result.am_supply);
            addedNode.setDataValue("um_supply", result.um_supply);
            addedNode.setDataValue("cd_wh", result.cd_wh);
            addedNode.setDataValue("nm_wh", result.nm_wh);
            addedNode.setDataValue("dc_rmk", result.dc_rmk);
            addedNode.setDataValue("dt_rtn_plan", result.dt_rtn_plan);
            addedNode.setDataValue("dt_so", result.dt_so);
          }
        }
      });
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_req = selectedRow.no_req;
      const dt_req = selectedRow.dt_req || "";
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
      setSelectedDocu(no_req);
      setSelectedDtDocu(dt_req);
    }
  };

  const onCellValueChanged1 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    if (colId === "cd_cust") {
      rowNode.setDataValue("cd_cust_dlv", rowData.cd_cust);
      rowNode.setDataValue("nm_cust_dlv", rowData.nm_cust_sort);
    }
    CalAmBulk(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };

  const onCellValueChanged2 = async (event: any) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };

  const setFooterDataToRow = () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const footerData = gridRefs.current["grid2"].current.getFooterData();
    if (focusedNodeH) {
      focusedNodeH.setDataValue("am", footerData.am);
      focusedNodeH.setDataValue("am_k", footerData.am_k);
      focusedNodeH.setDataValue("am_vat", footerData.am_vat);
      focusedNodeH.setDataValue("am_supply", footerData.am_supply);
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onCellValueChanged: onCellValueChanged1,
          onBeforeAddRow: onBeforeAddRow1,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChanged2,
          onBeforeAddRow: onBeforeAddRow2,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "반품정보" }}
            events={grids.grid1.events}
            filter={{ refs: [gridRefs.current["grid2"]], columns: ["no_req"] }}
            header={
              <div className="flex justify-end">
                <SnButton
                  text={"반품적용"}
                  onClick={() => {
                    onGrid1BtnsClick("btnApply");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{ rowSelection: "multiple", title: "상세정보" }}
            events={grids.grid2.events}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={0}
          selectedDtDocu={selectedDtDocu}
        />
      </div>
    </div>
  );
});

export default SN_SAL_ISU_REG_004;
